/**
 * KanbanViewEditor.js
 */

import PropTypes from "prop-types";
import { memo } from "react";
import KanbanFieldSelector from "./KanbanFieldSelector";

/**
 * KanbanViewEditor
 * 
 * A wrapper component that provides an interface for selecting a status field 
 * using the KanbanFieldSelector. It passes the selected fieldId and allows 
 * for changes to the view configuration.
 * 
 * @param {function} onChange - Function to handle field selection change.
 * @param {Array} statusFields - Array of status fields available for selection.
 * @param {Object} view - The current view configuration.
 * @param {Object} view.settings - The settings object containing the `fieldId`.
 * @param {number} view.viewId - The ID of the current view.
 */
const KanbanViewEditor = ({
  onChange = () => { },
  statusFields,
  view,
}) => (
  <KanbanFieldSelector
    onChange={onChange}
    selectedFieldId={view.settings?.fieldId}
    statusFields={statusFields}
    viewId={view.viewId}
  />
);

KanbanViewEditor.propTypes = {
  onChange: PropTypes.func.isRequired,
  statusFields: PropTypes.arrayOf(
    PropTypes.shape({
      fieldId: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  view: PropTypes.shape({
    settings: PropTypes.shape({
      fieldId: PropTypes.oneOf([undefined, PropTypes.number]),
    }),
    viewId: PropTypes.number.isRequired,
  }).isRequired,
};

KanbanViewEditor.displayName = "KanbanViewEditor";

export default memo(KanbanViewEditor);
